// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import  browser from './utils/browser.js'
import {axios} from './utils/https.js'
import {$showIntroduce} from './mixins/mixins.js'
import store from './store'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.prototype.$url = "http://4dscene.4dage.com/wuhu/JingGangShan/images".replace("http:",window.location.protocol);
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': false, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.directive('trigger',{
  inserted:function(el,binding) {
    console.log(el)
    el.click();
  }
})
Vue.mixin({
  methods:{
    $showIntroduce
  }
})

Vue.prototype.$mobile = browser.mobile
Vue.prototype.$https = axios;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js